import React from 'react';
import LegalPageLayout from './LegalPageLayout';
import { termsContent } from '../../data/termsContent';

const TermsOfUse = () => {
  return <LegalPageLayout title="Terms of Use" content={termsContent} />;
};

export default TermsOfUse; 